export default __webpack_public_path__ + "static/media/course-selector-bg.png";